import { updateDoc, doc } from "firebase/firestore";
import { firebaseDB } from "../../firebase";
import { Transaction } from "../../types/budgethelper";

export const useUpdateTransaction = () => {
  const updateTransaction = async (transactionId: string, updates: Partial<Transaction>) => {
    const transactionDoc = doc(firebaseDB, "transactions", transactionId);
    await updateDoc(transactionDoc, updates);
  };
  return { updateTransaction };
};
